// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}


.sidebar {
  width: 250px; /* Largura fixa da sidebar */
}

.main-content {
  flex-grow: 1; /* O conteúdo principal ocupa o restante do espaço */
  padding: 20px;
}

/* src/App.css */
@font-face {
  font-family: 'Good Times Bold';
  src: url('http://131.255.179.139:8080/Good-Times/GOODTIME.TTF') format('truetype');
}

body {
  font-family: 'Good Times Bold', sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.typewriter-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.typewriter {
  font-size: 3rem;
  white-space: nowrap;
  overflow: hidden;
  border-right: 0.15em solid #00aaff;
  animation: blink-caret 0.75s step-end infinite;
}

.sonik {
  color: white; /* Sonik em branco */
}

.hub {
  color: #00aaff; /* Hub em azul claro */
}

/* Animação de escrita */
@keyframes type {
  from { width: 0; }
  to { width: 8ch; } /* Quantidade de caracteres a serem animados */
}

/* Animação do cursor piscante */
@keyframes blink-caret {
  from, to { border-color: transparent; }
  50% { border-color: #00aaff; }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;;AAGA;EACE,YAAY,EAAE,4BAA4B;AAC5C;;AAEA;EACE,YAAY,EAAE,oDAAoD;EAClE,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,8BAA8B;EAC9B,kFAAkF;AACpF;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,YAAY,EAAE,oBAAoB;AACpC;;AAEA;EACE,cAAc,EAAE,sBAAsB;AACxC;;AAEA,wBAAwB;AACxB;EACE,OAAO,QAAQ,EAAE;EACjB,KAAK,UAAU,EAAE,EAAE,8CAA8C;AACnE;;AAEA,gCAAgC;AAChC;EACE,WAAW,yBAAyB,EAAE;EACtC,MAAM,qBAAqB,EAAE;AAC/B","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n.sidebar {\n  width: 250px; /* Largura fixa da sidebar */\n}\n\n.main-content {\n  flex-grow: 1; /* O conteúdo principal ocupa o restante do espaço */\n  padding: 20px;\n}\n\n/* src/App.css */\n@font-face {\n  font-family: 'Good Times Bold';\n  src: url('http://131.255.179.139:8080/Good-Times/GOODTIME.TTF') format('truetype');\n}\n\nbody {\n  font-family: 'Good Times Bold', sans-serif;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n.typewriter-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n.typewriter {\n  font-size: 3rem;\n  white-space: nowrap;\n  overflow: hidden;\n  border-right: 0.15em solid #00aaff;\n  animation: blink-caret 0.75s step-end infinite;\n}\n\n.sonik {\n  color: white; /* Sonik em branco */\n}\n\n.hub {\n  color: #00aaff; /* Hub em azul claro */\n}\n\n/* Animação de escrita */\n@keyframes type {\n  from { width: 0; }\n  to { width: 8ch; } /* Quantidade de caracteres a serem animados */\n}\n\n/* Animação do cursor piscante */\n@keyframes blink-caret {\n  from, to { border-color: transparent; }\n  50% { border-color: #00aaff; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
